export const jobTitles = [
  'Administrative Assistant',
  'Assistant Director',
  'Assistant Principal',
  'Assistant Superintendent',
  'Coordinator',
  'Counselor',
  'Curriculum Coordinator',
  'Director',
  'Grant Manager',
  'Intern',
  'Librarian',
  'OST Facilitator',
  'OST Multi-Site Administrator',
  'OST Site Administrator',
  'Parent',
  'Principal',
  'Program Coordinator',
  'School Administrator',
  'School Nurse',
  'School Psychologist',
  'Secretary',
  'Social Worker',
  'Specialist',
  'Student',
  'Superintendent',
  'Support Staff',
  'Teacher',
  'Teaching Assistant',
  'Volunteer',
]

export const jobRolesLabel = 'Which best describes your role?*'
export const schoolLookupLabel = 'Tell us about your school or organization:*'

export const jobRoles = [
  {
    id: 'Principal',
    name: 'Principal or head of school',
  },
  {
    id: 'Assistant Principal',
    name: 'Assistant or vice principal',
  },
  {
    id: 'Teacher',
    name: 'Teacher (teaching assistant, paraprofessional)',
  },
  {
    id: 'Specialist',
    name:
      'School Counselor or specialist (psychologist, social worker, librarian, nurse)',
  },
  {
    id: 'Support Staff',
    name: 'School support staff (administrative, secretary, office staff)',
  },
  {
    id: 'Program Staff',
    name: 'Before- or after-school program staff',
  },
  {
    id: 'District Staff',
    name: 'District administrator or staff',
  },
  {
    id: 'Caregiver',
    name: 'Caregiver (parent, guardian, other family, tutor, mentor)',
  },
  {
    id: 'Not Listed',
    name: 'Not listed',
  },
]



// WEBPACK FOOTER //
// ./src/lib/meta.js